import { dispatcher, ingenuity,IEvent, SpineBase, Container, clone } from "@quest/base-core";

import { StickyFeatureView } from "./StickyFeatureView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";
import { FreeGameModel, SlotEventConstants } from "@quest/slot-core";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";


export class StickyFeatureViewController {
  protected view: StickyFeatureView;
  private stickySymbolContainer:Container;
  private stickyData:any[];
  protected fgModel: FreeGameModel;
  
    constructor(view:StickyFeatureView,model : FreeGameModel){
      this.view = view;
      this.subscribeEvents();
      this.initializeElemens();
      this.fgModel = model;
    }

    private initializeElemens():void{
      this.stickySymbolContainer = this.view.getContainerByID("stickySymbolContainer");
    }

    private subscribeEvents() :void{
        this.unubscribeEvents();
        dispatcher.on(eventDispatchers.PLAY_STICKY_WIN_ANIM,this.playStickyWinAnim,this);
        dispatcher.on(eventDispatchers.STOP_STICKY_WIN_ANIM,this.stopStickyWinAnim,this);
        dispatcher.on(eventDispatchers.ADD_STICKY_RANDOM_WILD, this.addStickyWildSymbol, this)
        dispatcher.on(eventDispatchers.HIDE_STICKY_WILD_CONTAINER, this.hideStickyWildContainer, this)

    }
    private unubscribeEvents():void{
        dispatcher.off(eventDispatchers.PLAY_STICKY_WIN_ANIM,this.playStickyWinAnim,this)
        dispatcher.off(eventDispatchers.STOP_STICKY_WIN_ANIM,this.stopStickyWinAnim,this)
        dispatcher.off(eventDispatchers.ADD_STICKY_RANDOM_WILD, this.addStickyWildSymbol, this)
        dispatcher.off(eventDispatchers.HIDE_STICKY_WILD_CONTAINER, this.hideStickyWildContainer, this)
      }

      private hideStickyWildContainer(): void {
        this.stickySymbolContainer.alpha = 0;
        this.stickySymbolContainer.visible = false;
        this.stickySymbolContainer.removeChildren();
        this.stickyData = [];
        (ingenuity.parserModel as GameParserModel).setStickyWildData(null);
        (ingenuity.parserModel as GameParserModel).setCollectWildData(null);
        (ingenuity.parserModel as GameParserModel).setStickyWildDataRawData(null);
    }
 
    /**
     * add sticky wild to container
     */
    private addStickyWildSymbol(): void {
        this.stickySymbolContainer.visible = true;
        this.stickySymbolContainer.alpha = 1;
        this.stickyData = [];
        this.stickyData = (ingenuity.parserModel as GameParserModel).getCollectWildData().wildPos;
        if(this.stickyData.length){
          this.addStickyToContainer();
        } else{
          this.onAddedStickyWildsOnReel();
        }
    }

    /**
     * add stciky wild one by one
     * @param index 
     */
    private addStickyToContainer(index:number = 0):void{
    this.stickyData.forEach((element,index) => {
    let childExist = this.stickySymbolContainer.getChildByName(`wildSpine_${this.stickyData[index][0]}_${this.stickyData[index][1]}`);
    if(!childExist){
      let wildSpine = clone(ingenuity.assetsData.getJSONById("main_data").stickyWildSymbol['symbol_wild']);
      wildSpine.type = "spine";
      let child = this.view.createSpineClone(wildSpine);
      child.visible = true;
      child.name = `wildSpine_${this.stickyData[index][0]}_${this.stickyData[index][1]}`;
      child.json.id = `wildSpine_${this.stickyData[index][0]}_${this.stickyData[index][1]}`;
      child.x = this.view.json.symWidth * this.stickyData[index][0]
      child.y = this.view.json.symHeight * this.stickyData[index][1];
      this.stickySymbolContainer.addChild(child);
      this.fgModel.getReelGrid()[this.stickyData[index][0]][this.stickyData[index][1]];
      this.playAnimations(child,index);
      let data:any = {reel:this.stickyData[index][0],col:this.stickyData[index][1]};
      dispatcher.fireEvent(eventDispatchers.HIDE_WILD_SYMBOL_ON_REEL,data);
      } else {
        if(this.stickyData.length -1 == index){
          this.onAddedStickyWildsOnReel();
        }
      }
    });
    }
 
    playAnimations(child: SpineBase,index:number) {
      if ((ingenuity.parserModel as platformModel).getFreeGameBroken()) {
        child.playAnim("locked_static", false, 0);
        if(this.stickyData.length -1 == index){
          this.onAddedStickyWildsOnReel();
        }
      } else {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.STICKY_SYMBOL_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
        child.playAnim("locked");
        child.onComplete.addOnce(() => {
          child.playAnim("locked_static");
          if(this.stickyData.length -1 == index){
            this.onAddedStickyWildsOnReel();
          }
        });
      }
    }

    /**
     * when wild is added to reel
     */
    private onAddedStickyWildsOnReel(): void {
        dispatcher.fireEvent(SlotEventConstants.FG_ENABLE_STOP_BTN);
        dispatcher.fireEvent(eventDispatchers.STICKY_WILD_ADDED);
    }

          /**
   * This will play wining aimation of sticky symbol
   * @param evt IEvent
   */
  private playStickyWinAnim(evt: IEvent) {
    const stickyOffsets: number[][] = (ingenuity.parserModel as GameParserModel).getStickyWildData().wildPos;
    const sym:SpineBase = this.stickySymbolContainer.getChildByName(`wildSpine_${stickyOffsets[evt.data][0]}_${stickyOffsets[evt.data][1]}`) as SpineBase;
    sym.visible = true;
    const winKey ="win_locked";
    sym.playAnim(winKey, true, 0);
  }

  /**to stop sticy symbol animations on new spin */
  private stopStickyWinAnim(): void {
    const stickySym: any = (ingenuity.parserModel as GameParserModel).getStickyWildData();
    let stickyOffsets: number[][];
    if(stickySym){
      stickyOffsets = stickySym.wildPos;
    }
    if (stickyOffsets && stickyOffsets.length) {
      for (const data of stickyOffsets) {
        const row: number = data[0];
        const col: number = data[1];
        const sym:SpineBase = this.stickySymbolContainer.getChildByName(`wildSpine_${row}_${col}`) as SpineBase
        sym.playAnim("locked_static", false, 0);
      }
    }
  }

}
